export default (medicationDispense) => {
  return Object.assign({
    'id': null,
    'resourceType': 'MedicationDispense',
    'status': 'completed',
    'medicationReference': {},
    'subject': {},
    'supportingInformation': [],
    'performer': [],
    'location': {},
    'authorizingPrescription': {},
    'type': {},
    'quantity': {
      'value': 1,
      'code': null,
      'system': 'http://terminology.hl7.org/CodeSystem/v3-orderableDrugForm'
    },
    'daysSupply': {},
    'whenPrepared': '',
    'destination': {},
    'receiver': [],
    'dosageInstruction': [],
    'note': '',
    'substitution': {
      'wasSubstituted': false
    }
  }, medicationDispense);
};
